/* MULTIMAG: comportamente proprii — favorite (pe toate paginile), „Alegeți mărimea” și lista de caracteristici pe pagina de produs. */
(function () {
  'use strict';

  /* ---------- Favorite (salvate în browser, fără cont) ---------- */
  var FAV_KEY = 'mm_fav';
  function favGet() {
    try { var a = JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function favSet(a) { try { localStorage.setItem(FAV_KEY, JSON.stringify(a)); } catch (e) {} }
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 8 3.3 4.5 6.8 4.5c2 0 3.4 1.1 4.2 2.4h2c.8-1.3 2.2-2.4 4.2-2.4 3.5 0 5.4 3.5 4.1 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';

  function favRefresh() {
    var list = favGet();
    document.querySelectorAll('[data-mm-fav]').forEach(function (b) {
      var on = list.indexOf(b.dataset.mmFav) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Scoate din favorite' : 'Adaugă la favorite');
      b.title = on ? 'Salvat la favorite' : 'Adaugă la favorite';
    });
    var c = document.querySelector('.mm-fav-header__count');
    if (c) { c.textContent = list.length; c.hidden = list.length === 0; }
  }

  function favHeader() {
    if (document.querySelector('.mm-fav-header')) return;
    var cart = document.getElementById('cart-icon-bubble');
    if (!cart || !cart.parentNode) return;
    var a = document.createElement('a');
    a.href = '/pages/wish-list';
    a.className = 'header__icon link focus-inset mm-fav-header';
    a.setAttribute('aria-label', 'Produse favorite');
    a.innerHTML = '<span class="svg-wrapper">' + HEART + '</span><span class="mm-fav-header__count" hidden>0</span>';
    cart.parentNode.insertBefore(a, cart);
    if (!document.querySelector('.mm-phone-header')) {
      var ph = document.createElement('a');
      ph.href = 'tel:+40756424185';
      ph.className = 'header__icon link focus-inset mm-phone-header';
      ph.setAttribute('aria-label', 'Sună-ne: 0756 424 185');
      ph.innerHTML = '<span class="svg-wrapper"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 3h4l2 5-2.5 1.5a11 11 0 0 0 6 6L16 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 5a2 2 0 0 1 2-2z"/></svg></span><span class="mm-phone-header__txt"><small>Suport comenzi</small>0756 424 185</span>';
      var first = cart.parentNode.firstElementChild;
      cart.parentNode.insertBefore(ph, first);
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mm-fav]');
    if (!b) return;
    e.preventDefault();
    var list = favGet(), h = b.dataset.mmFav, i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    favSet(list);
    favRefresh();
    if (b.dataset.mmFavRemove) { var card = b.closest('.mm-favlist__item'); if (card) card.remove(); favEmpty(); }
  });

  function money(c) {
    var s = (c / 100).toFixed(2).split('.');
    return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + s[1] + ' lei';
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function favEmpty() {
    var grid = document.querySelector('.mm-favlist__grid');
    var empty = document.querySelector('.mm-favlist__empty');
    if (grid && empty) empty.hidden = grid.children.length > 0;
  }
  function favPage() {
    if (!/^\/pages\/wish-list\/?$/.test(window.location.pathname)) return;
    var host = document.querySelector('#MainContent .page-width') || document.getElementById('MainContent');
    if (!host) return;
    var box = document.createElement('div');
    box.className = 'mm-favlist';
    box.innerHTML = '<p class="mm-favlist__empty" hidden>Nu ai produse la favorite. Apasă pe inimioara de lângă butonul „Adăugați în coș” ca să salvezi un produs aici.</p><div class="mm-favlist__grid"></div>';
    host.appendChild(box);
    var grid = box.querySelector('.mm-favlist__grid');
    var list = favGet();
    if (!list.length) { favEmpty(); return; }
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      products.forEach(function (p) {
        if (!p) return;
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
        var el = document.createElement('div');
        el.className = 'mm-favlist__item';
        el.innerHTML =
          '<a class="mm-favlist__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<a class="mm-favlist__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<span class="mm-favlist__price">' + (p.price_varies ? 'de la ' : '') + money(p.price_min) + '</span>' +
          '<div class="mm-favlist__actions"><a class="button mm-favlist__go" href="' + esc(p.url) + '">Vezi produsul</a>' +
          '<button type="button" class="mm-fav is-on" data-mm-fav="' + esc(p.handle) + '" data-mm-fav-remove="1" aria-label="Scoate din favorite">' + HEART + '</button></div>';
        grid.appendChild(el);
      });
      favEmpty();
    });
  }

  /* ---------- Pagina de produs ---------- */
  function sizeFieldsets(info) {
    return Array.prototype.filter.call(info.querySelectorAll('variant-selects fieldset'), function (f) {
      var l = f.querySelector('legend');
      var t = (l ? l.textContent : '').toLowerCase();
      return /m[aă]rime|size|m[aă]sur/.test(t);
    });
  }

  function markSizes() {
    document.querySelectorAll('product-info[data-section]').forEach(function (info) {
      sizeFieldsets(info).forEach(function (f) { f.classList.add('mm-size-fieldset'); });
    });
  }

  function needSize() {
    var info = document.querySelector('product-info[data-section]');
    if (!info || !info.querySelector('variant-selects')) return;
    if (/[?&]variant=/.test(window.location.search)) return;
    if (!sizeFieldsets(info).length) return;
    var sectionId = info.dataset.section;
    var btnId = 'ProductSubmitButton-' + sectionId;

    function mark() {
      sizeFieldsets(info).forEach(function (f) { f.classList.add('mm-size-fieldset'); });
      if (!info.classList.contains('mm-need-size')) return;
      var b = document.getElementById(btnId);
      if (b && !b.disabled) { var s = b.querySelector('span'); if (s) s.textContent = 'Alegeți mărimea'; }
    }
    function done() {
      if (!info.classList.contains('mm-need-size')) return;
      info.classList.remove('mm-need-size');
      var b = document.getElementById(btnId);
      if (b && !b.disabled) { var s = b.querySelector('span'); if (s) s.textContent = window.variantStrings && window.variantStrings.addToCart ? window.variantStrings.addToCart : 'Adăugați în coș'; }
    }

    info.classList.add('mm-need-size');
    mark();

    info.addEventListener('click', function (e) {
      var input = e.target.closest('.mm-size-fieldset input, .mm-size-fieldset label');
      if (input) { setTimeout(done, 0); }
    }, true);

    document.addEventListener('click', function (e) {
      var b = e.target.closest('#' + btnId);
      if (!b || !info.classList.contains('mm-need-size')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var f = sizeFieldsets(info)[0];
      if (!f) return;
      f.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var box = f.closest('variant-selects') || f;
      box.classList.remove('mm-flash');
      void box.offsetWidth;
      box.classList.add('mm-flash');
    }, true);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(mark, 0); });
    }
  }

  function cap(s) { s = s.trim().toLowerCase(); return s.charAt(0).toUpperCase() + s.slice(1); }
  function specList() {
    var box = document.getElementById('ProductAccordion-mm-descriere');
    if (!box || box.dataset.mmSpec) return;
    box.dataset.mmSpec = '1';
    var re = /(^|[\s.;,])([A-ZĂÂÎȘŞȚŢ][A-ZĂÂÎȘŞȚŢ \-\/]{2,30}):\s*/g;
    var nodes = Array.prototype.slice.call(box.querySelectorAll('p'));
    if (!nodes.length) nodes = [box];
    nodes.forEach(function (p) {
      if (p !== box && p.children.length > 3) return;
      var text = p.textContent.replace(/\s+/g, ' ').trim();
      var parts = [], m, last = null, intro = '';
      re.lastIndex = 0;
      while ((m = re.exec(text)) !== null) {
        var start = m.index + m[1].length;
        if (last) last.value = text.slice(last.end, start).trim();
        else intro = text.slice(0, start).trim();
        last = { label: m[2], end: re.lastIndex };
        parts.push(last);
      }
      if (parts.length < 2) return;
      last.value = text.slice(last.end).trim();
      var html = intro ? '<p>' + esc(intro) + '</p>' : '';
      html += '<dl class="mm-spec">' + parts.map(function (x) {
        return '<div class="mm-spec__row"><dt>' + esc(cap(x.label)) + '</dt><dd>' + esc(x.value.replace(/[.;,]\s*$/, '')) + '</dd></div>';
      }).join('') + '</dl>';
      if (p === box) { box.innerHTML = html; return; }
      var wrap = document.createElement('div');
      wrap.innerHTML = html;
      p.replaceWith.apply(p, Array.prototype.slice.call(wrap.childNodes));
    });
  }

  function init() {
    favHeader();
    favRefresh();
    favPage();
    if (document.querySelector('product-info[data-section]')) {
      markSizes();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(markSizes, 0); });
      }
      needSize();
      specList();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* MULTIMAG runda 5: meniul derulant rămâne mereu în ecran (aliniat sub categorie, mutat spre stânga dacă nu încape) */
(function () {
  function place(d) {
    var c = d.querySelector('.mega-menu__content');
    if (!c || window.innerWidth < 990) return;
    c.style.left = '0px'; c.style.right = 'auto';
    var vw = document.documentElement.clientWidth, m = 16;
    var r = c.getBoundingClientRect();
    var shift = 0;
    if (r.right > vw - m) shift = r.right - (vw - m);
    if (r.left - shift < m) shift = r.left - m;
    if (shift) c.style.left = (-shift) + 'px';
  }
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.matches && d.matches('.header__inline-menu details.mega-menu') && d.open) place(d);
  }, true);
  window.addEventListener('resize', function () {
    document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach(place);
  });
})();
